import { createTheme } from '@material-ui/core';

export const convertToDiscussionTheme = (classroomTheme) => {
  const typographyTheme = createTheme({
    typography: {
      fontFamily: classroomTheme.fonts.content,
      h3: { fontSize: 34, fontWeight: 600, lineHeight: 1.46 },
    },
  });

  return {
    palette: {
      primary: {
        darker: classroomTheme.colors.primaryDarker,
        dark: classroomTheme.colors.primaryDark,
        main: classroomTheme.colors.primary,
        light: classroomTheme.colors.primaryLight,
        lighter: classroomTheme.colors.primaryLighter,
        contrastText: 'hsla(0, 0%, 100%, 1)',
      },
    },
    typography: typographyTheme.typography,
    breakpoints: { values: { sm: 768 } },
    components: {
      MuiButton: {
        defaultProps: {
          variant: 'contained',
        },
        styleOverrides: {
          root: {
            minWidth: '100px',
            borderRadius: '100px',
            boxShadow: 'none',
            ':hover': {
              boxShadow: 'none',
            },
          },
          outlined: ({ theme }) => ({
            border: `2px solid ${theme.palette.primary.main}`,
            ':hover': {
              border: `2px solid ${theme.palette.primary.main}`,
            },
          }),
          sizeSmall: ({ theme }) => ({
            fontSize: 14,
            height: 28,
            padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
            lineHeight: '21px',
          }),
          sizeMedium: ({ theme }) => ({
            fontSize: 14,
            height: 40,
            padding: `${theme.spacing(1.25)}px ${theme.spacing(3)}px`,
            lineHeight: 1.5,
          }),
          sizeLarge: ({ theme }) => ({
            fontSize: 18,
            height: 50,
            padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
            lineHeight: '26px',
          }),
        },
      },
      MuiSnackbar: {
        styleOverrides: {
          root: { '.MuiAlert-root': { minWidth: 300, fontWeight: 400 } },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: { borderRadius: '8px', minHeight: '36px' },
        },
      },
      MuiPopover: {
        styleOverrides: {
          paper: {
            borderRadius: '12px',
            '.MuiList-root': {
              padding: '6px',
            },
          },
        },
      },
    },
  };
};
